function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2.358,
  d: "M26.583.548v49.713M.549 24.751h49.713"
});

function SvgCalculatorIcon1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 51 51",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEiIGhlaWdodD0iNTEiIHZpZXdCb3g9IjAgMCA1MSA1MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGxpbmUgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHgxPSIyNi41ODMzIiB5MT0iMC41NDgyMTgiIHgyPSIyNi41ODMzIiB5Mj0iNTAuMjYxMiIgIHN0cm9rZS13aWR0aD0iMi4zNTc1NyIvPgo8bGluZSBzdHJva2U9ImN1cnJlbnRDb2xvciIgeDE9IjAuNTQ4ODI4IiB5MT0iMjQuNzUxMyIgeDI9IjUwLjI2MTgiIHkyPSIyNC43NTEzIiBzdHJva2Utd2lkdGg9IjIuMzU3NTciLz4KPC9zdmc+Cg==";
export { SvgCalculatorIcon1 as ReactComponent };